import { Clipboard } from '@angular/cdk/clipboard';
import { ChangeDetectorRef, Component, Input, NgZone, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { interval } from 'rxjs';
import { SubSink } from 'subsink';

import { FreyaNotificationsService } from '../../services/freya-notifications.service';
import { ResponsiveHelperService } from '../../services/responsive-helper.service';
import { TimezoneHelperService } from '../../services/timezone-helper.service';
import { MS_ONE_SECOND } from '../../time';
import { appropriateTimeMeasurement } from '../appropriate-time-measurement.pipe';

@Component({
  selector: 'app-time-since',
  templateUrl: './time-since.component.html',
  styleUrls: ['./time-since.component.scss']
})
export class TimeSinceComponent implements OnInit, OnChanges, OnDestroy {

  @Input() unixTime: number;

  @Input() refreshInterval = MS_ONE_SECOND;

  /** Pre-computed display string. Updated outside Angular's zone to avoid triggering
   *  full-app change detection on every tick — important when many instances are on screen. */
  displayText = '';

  subs = new SubSink();

  constructor(
    public responsiveHelper: ResponsiveHelperService,
    private notify: FreyaNotificationsService,
    private clipboard: Clipboard,
    private timezoneHelper: TimezoneHelperService,
    private zone: NgZone,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.updateDisplay();
    // Run the interval outside Angular's zone so it does not trigger a full-app
    // change detection cycle on every tick. We only call detectChanges() on this
    // component when the displayed text actually changes.
    this.zone.runOutsideAngular(() => {
      this.subs.sink = interval(this.refreshInterval).subscribe(() => {
        const next = appropriateTimeMeasurement(this.unixTime * 1000, true);
        if (next !== this.displayText) {
          this.displayText = next;
          this.cdr.detectChanges();
        }
      });
    });
  }

  ngOnChanges(): void {
    this.updateDisplay();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private updateDisplay(): void {
    this.displayText = appropriateTimeMeasurement(this.unixTime * 1000, true);
  }

  copyTimeToClipboard() {
    const time = this.timezoneHelper.dayjs(this.unixTime * 1000);
    const formatted = time.format('YYYY/MM/DD HH:mm:ss')

    if(this.clipboard.copy(formatted)) {
      this.notify.info('Copied to clipboard', formatted);
    } else {
      this.notify.error('Failed to copy to clipboard', formatted);
    }

  }

}
